const keyboardSkeleton = () => (`
  <button class="skltn"></button>
  <button class="skltn"></button>
  <button class="skltn"></button>
  <button class="skltn"></button>
  <button class="skltn"></button>
  <button class="skltn"></button>
`);

export default keyboardSkeleton;
